import CandidateAgent from "../CandidateAgent";

export default function () {
	return (
		<>
			<div className="card">
				<CandidateAgent header={"Agents"} />
			</div>
		</>
	);
}
